import axios from "axios"
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react"

import { FormControl, InputLabel, Input, FormHelperText, Alert, Divider } from "@mui/material"
import WebService from "@util/webService"
import { copyProperties, encodeParams, getAction, getNow, printVariable } from "@util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "@components/FlatButton"
import useSnackbar from "@hooks/useSnackbar"
import MyTableHead from "@components/MyTableHead"
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator"
import MyDialog from "@components/MyDialog"
import useForm from "@hooks/useForm"
import Box from "@mui/material/Box"

// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"

import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { useNavigate } from "react-router-dom"
import DialogTitle from "@mui/material/DialogTitle"
import Dialog from "@mui/material/Dialog"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import useAlert from "@hooks/useAlert";
const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`

const ProfileCompanyManagerPart = ({ company, manager, dialogHandler, callback }) => {
	printVariable("company", company)
	printVariable("manager", manager)
	const dateFormat = "YYYY-MM-DD HH:mm:ss"

	const defRecord = {}
	defRecord.schoolList = []
	defRecord.schoolRltnList = []
	defRecord.companyRltnList = []

	const [openSnackbar, renderSnackbar] = useSnackbar()
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
	const [targetList, set_targetList] = useState([])
  const [changed, set_changed] = useState(false)

	// redux
	const codeGroups = useSelector((state) => state.codeGroupReducer)
	const codes = useSelector((state) => state.codeReducer)
	const schools = useSelector((state) => state.schoolReducer)
	const account = useSelector((state) => state.accountReducer)

  const {alert, renderAlert} = useAlert()

	const validate = () => {}

	const [schoolList, set_schoolList] = useState([])

	const navigate = useNavigate()

	useEffect(() => {
		onLoad()
	}, [])

	const onLoad = async () => {
		openIndicator()

		fetchSchools()
		fetchSchoolManager()

		closeIndicator()
	}

	const fetchSchools = async () => {
		const url = `/rltn/company/school/${company.id}`
		const resp = await WebService.get(url)
		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			set_schoolList(records)
		} else {
			openSnackbar(resp.repMessage)
		}
	}

	const fetchSchoolManager = async () => {
		const url = `/rltn/school/manager/${company.id}/${manager.id}`
		const resp = await WebService.get(url)
		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			const targetList = []
			records.forEach((r) => {
				const d = { manager: manager, company: company, school: r.school }
				targetList.push(d)
			})
			set_targetList(targetList)
		} else {
			alert(resp.repMessage)
		}
	}

	const onSubmit = async () => {
		const data = []
		targetList.forEach((t) => {
			const d = { userId: t.manager.id, schoolId: t.school.id, rltnCode: "S004", statCode: "S002", regTime: getNow() }
			data.push(d)
		})
    console.log('targetList', targetList)

		const params = {}
		const url = `/rltn/school/manager/assign/${company.id}/${manager.id}`
		const resp = await WebService.post(url, data, params)
		if (resp.repCode === "ack") {
			alert("설정되었습니다.", () => handleClose())
		} else {
      alert(resp.repMessage)
		}
	}

	const [activeRow, errors, formLoading, handleChange, handleSubmit] = useForm({
		initialValues: { ...account, schoolRltnList: [], companyRltnList: [] },
		onSubmit: onSubmit,
		validate: validate,
	})

	const filterOptions = (options, state) => {
		let newOptions = []
		newOptions = options.filter((o) => o.name.includes(state.inputValue)).slice(0, 1000)
		return newOptions
	}

	const handleClose = (event, reason) => {
		if (reason && reason === "backdropClick") {
			return
		} else {
			dialogHandler[1](false)
			if (callback) {
				callback()
			}
		}
	}

	return (
		<Fragment>
			<Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='md' fullWidth>
				<DialogTitle>
					<Typography variant='h5' align='center'>
						매니저 설정
					</Typography>
					<Divider></Divider>
				</DialogTitle>
				<DialogContent>
					<br />
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<Autocomplete
								disablePortal
								options={schoolList}
								filterOptions={filterOptions}
								onChange={async (e, v) => {
									if (v) {
										const newTargetLit = [...targetList]
										const found = newTargetLit.find((r) => +r.school.id === +v.id)
										if (!found) {
											const d = { manager: manager, company: company, school: { ...v } }
											newTargetLit.push(d)
											set_targetList(newTargetLit)
											set_changed(true)
										} else {
                      alert("이미 같은 학교가 선택되어 있습니다.")
										}
									}
								}}
								size='small'
								getOptionLabel={(option) => option.name}
								renderInput={(params) => <TextField {...params} label='학교명 선택' />}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<MUITable>
								<TableHead>
									<TableRow>
										<TableCell>제거</TableCell>
										<TableCell>매니저</TableCell>
										<TableCell>위탁업체</TableCell>
										<TableCell>학교</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{targetList.map((row, index) => {
										return (
											<TableRow>
												<TableCell>
													<IconButton
														onClick={() => {
															const newTargetList = [...targetList]
															const idx = newTargetList.findIndex((t) => +t.company.id === +row.company.id && +t.school.id === +row.school.id)

															if (idx >= 0) {
																set_changed(true)
																newTargetList.splice(idx, 1)
																set_targetList(newTargetList)
															}
														}}>
														<RemoveCircleOutlineIcon />
													</IconButton>
												</TableCell>

												<TableCell>{row.manager.name}</TableCell>
												<TableCell>{row.company.name}</TableCell>
												<TableCell>{row.school.name}</TableCell>
											</TableRow>
										)
									})}
								</TableBody>
							</MUITable>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>닫기</Button>
					<Button onClick={onSubmit} variant='contained'>설정하기</Button>
				</DialogActions>
			</Dialog>
			{renderSnackbar()}
			{renderIndicator()}
      {renderAlert()}
		</Fragment>
	)
}

export default ProfileCompanyManagerPart
